<template>
    <div class="max-w-6xl mx-auto p-6">
        <ul class="flex gap-4 flex-wrap">
            <li>Browse Karaokes In</li>
            <li v-for="c in majorCities" :key="c.slug">
                <a :href="`/in/${c.slug}`" rel="external">{{ c.name }}</a>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
    import majorCities from "@/lib/50-major-cities.json";
</script>
